import React from 'react';
import { useHistory } from 'react-router-dom';
import { SessionState } from '../../../reducers/auth/session';
import { Grid, Paper, Typography, Button } from '@mui/material';
import { AppState } from '../../../reducers/index';
import { connect } from 'react-redux';
import littleIS from '../../images/littleIS.png'
import { useTranslation } from 'react-i18next';
import { PERSON } from '../../../models/User';
import { roleToURLPrefix } from '../../../App';

interface Props {
  session: SessionState;
}

const HeadSalesDashboard: React.FC<Props> = ({ session}) => {
  const history = useHistory();
  const { t } = useTranslation('dashboard')

  var tasks: any[] = []

  if (session.shouldUpdatePassword) tasks.push(
    <Task key="updatePass">
      Tenés una contraseña automática, por favor cambiala a una personal en <Button size="small"
       onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/profile`)}
      >Mi Perfil</Button>.
    </Task>
  )

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper>
            <Typography variant="body1">
              {t('welcome')}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

/*
        
        <Grid item xs={12}>
          <Typography variant="h6">
            Tareas pendientes
          </Typography>
        </Grid>
        {tasks.length ? tasks : <Grid item xs={12}>
          <Typography variant="body1">
            No tenés tareas pendientes
            &nbsp;&nbsp;<ThumbUp />
          </Typography>
        </Grid>}

        <Grid item xs={12}>
          <Typography variant="h6">
            Recordatorios
          </Typography>
        </Grid>
        <InfoCard>Dato InfoCard.</InfoCard>
*/


type TaskProps = {
  children?: React.ReactNode
};

const Task: React.FC<TaskProps> = ({ children }) => {
  return <Grid item xs={4}>
    <Paper>
      <Typography variant="body1">
        <img alt="task" src={littleIS} />&nbsp;&nbsp;
        {children}
      </Typography>
    </Paper>
  </Grid>
}

const mapStateToProps = (state: AppState) => ({
  session: state.session
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(HeadSalesDashboard);
